import type { VFXEffectConfig, VFXPrimitive } from '../../VFXEffectRegistry';
import { abilityPalette } from '../../abilityPalette';
import { BARKSKIN_STATE_STYLE as bark, WILD_MARK_STATE_STYLE as wild } from '../statusPresentation.config';

const barkPalette = abilityPalette('barkskin')?.palette ?? [];
const wildPalette = abilityPalette('mark_of_the_wild')?.palette ?? [];

const BARKSKIN_STATE: VFXEffectConfig = {
  id: 'barkskin_state',
  name: 'Barkskin State',
  category: 'status',
  description: 'Separated bark plates with pale grain along the body edges',
  followTarget: 'player',
  primitives: bark.plates.flatMap(({ x, y }): VFXPrimitive[] => [
    {
      type: 'polygon', polygonPoints: bark.platePoints,
      offsetX: x, offsetY: y, color: barkPalette[0], alpha: bark.plateAlpha, depth: bark.depth,
    },
    {
      type: 'line', linePoints: bark.grainPoints, lineWidth: bark.edgeWidth,
      offsetX: x, offsetY: y, color: barkPalette[2], alpha: bark.edgeAlpha, depth: bark.depth + 1,
    },
  ]),
};

const MARK_OF_THE_WILD_STATE: VFXEffectConfig = {
  id: 'mark_of_the_wild_state',
  name: 'Mark of the Wild State',
  category: 'status',
  description: 'Three leaves and forked stems form a compact wild emblem beside the body',
  followTarget: 'player',
  primitives: [
    {
      type: 'polygon', polygonPoints: wild.tipLeafPoints, offsetX: wild.tipX, offsetY: wild.tipY,
      color: wildPalette[1], alpha: wild.leafAlpha, depth: wild.depth,
    },
    ...wild.leaves.map(({ x, y, mirror }): VFXPrimitive => ({
      type: 'polygon',
      polygonPoints: wild.sideLeafPoints.map((value, index) => index % 2 === 0 ? value * mirror : value),
      offsetX: x, offsetY: y,
      color: wildPalette[0], alpha: wild.leafAlpha, depth: wild.depth,
    })),
    ...wild.stemPaths.map((linePoints): VFXPrimitive => ({
      type: 'line', linePoints,
      lineWidth: wild.stemWidth, color: wildPalette[2], alpha: wild.stemAlpha, depth: wild.depth + 1,
    })),
  ],
};

export const DRUID_STATE_VFX: VFXEffectConfig[] = [BARKSKIN_STATE, MARK_OF_THE_WILD_STATE];
